<template>
  <div class="container-fluid vertical-spacing min-h-100">
    <SfHeading
      :title="$t('Browse by category')"
      :description="name"
      :level="level"
      class="sf-heading--left"
    />
    <Loader
      :loading="isLoading"
      :text="$t('Loading categories...')"
    >
      <div class="row">
        <div
          v-for="category in categories"
          :key="category.Id"
          class="col-xs-12 col-sm-6 col-md-3 col-lg-2"
        >
          <Level4CategoryMenuItem
            :category="category"
            @categorySelect="getCategories"
          />
        </div>
      </div>
    </Loader>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { SfHeading } from '@storefront-ui/vue';
import { Loader, breadcrumbs } from '@/modules/core';
import * as constants from '../../constants';
import Level4CategoryMenuItem from './Level4CategoryMenuItem.vue';

export default {
  name: 'Level4CategoryMenu',
  mixins: [breadcrumbs],
  components: {
    SfHeading,
    Loader,
    Level4CategoryMenuItem,
  },
  data() {
    return {
      level: 4,
      isLoading: false,
      name: this.$route.query.name,
    };
  },
  mounted() {
    this.emptyCategoriesPath();
    const { id, name } = this.$route.query;
    this.getCategories({ id, name });
  },
  computed: {
    ...mapGetters({
      categoriesPath: 'level4/categoriesPath',
      categories: 'level4/categories',
      filters: 'level4/filters',
    }),
  },
  methods: {
    getCategories({ id, name }) {
      this.isLoading = true;
      this.fetchCategories({
        ...this.filters,
        ...(!id ? { searchType: '' } : null),
        id: id || 0,
      })
        .then((data) => {
          this.isLoading = false;
          if (name) {
            this.name = name;
            this.pushCategoriesPath({
              text: name,
              link: `/level4?id=${id}&name=${encodeURI(name)}`,
            });
          }

          if (data && !data.length) {
            this.$router.push({
              name: 'Level4Category',
              params: {
                category: id,
                name,
              },
            });
          } else {
            this.routeBreadcrumbs(this.categoriesPath);
          }
        });
    },
    ...mapMutations({
      pushCategoriesPath: `level4/${constants.LEVEL4_CATEGORIES_PATH_PUSH}`,
      emptyCategoriesPath: `level4/${constants.LEVEL4_CATEGORIES_PATH_EMPTY}`,
    }),
    ...mapActions({
      fetchCategories: 'level4/fetchCategories',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";

.sf-heading {
  @include for-desktop {
    margin-bottom: var(--spacer-base);
  }
}
</style>
